import React, { useEffect, useState } from "react";
import { array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";

import MobilePlayStore from "../../../molecules/MobilePlayStore";
import StaticFooterLinks from "../../../molecules/StaticFooterLinks";
import FooterMenuGroup from "../../../molecules/FooterMenuGroup";
import Instagram from "../KishoraloFooter/Instagram";
import { Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import Youtube from "./Youtube";
import DefaultFooterLogo from "./DefaultFooterLogo";
import naLogo from "../../../../../assets/images/Na_logo.svg";

import { logoRenderer } from "../../../utils/react-utils";
import { getCurrentSite, completeUrlSetter } from "../../../utils/utils";
import { menuGroups } from "../../../helper/api";

import "./defaultFooter.m.css";

const DefaultFooterBase = ({
  publisherSettings,
  prothomaloMenuItems,
  pageType,
  publisherAttributes,
  socialLinks,
  currentPath,
  domainSlug,
  micrositesMenuItems,
  customSocialLinks,
  sections,
}) => {
  const [authMenu, setAuthMenu] = useState({});
  const footerLogo =
    domainSlug === "northamerica" ||
    getCurrentSite(currentPath) === "northamerica" ||
    getCurrentSite(currentPath) === "na" ? (
      <img src={`${assetify(naLogo)}`} alt="na-logo" styleName="na-logo" className="desktop-na-logo na-logo" />
    ) : (
      <DefaultFooterLogo />
    );
  const socialShareLinks = customSocialLinks.northamerica || socialLinks;
  const footerBottom = prothomaloMenuItems.find((item) => item.title === "Footer Bottom");
  const footerBottomLinks = footerBottom && footerBottom.children.length > 0 ? footerBottom.children : null;
  const initialFooterBottomLinks =
    footerBottomLinks && footerBottomLinks.length > 1 ? footerBottomLinks.slice(0, footerBottomLinks.length - 1) : null;
  const lastFooterBottomLinks =
    footerBottomLinks && footerBottomLinks.length > 0 ? footerBottomLinks[footerBottomLinks.length - 1] : null;

  const menuSetter = (group = getCurrentSite(currentPath)) => {
    menuGroups().then((res) => {
      const menu = get(res, ["menu-groups", group], []);
      const footerMenu = menu.items.filter((item) => item.title === "footer");
      const footerChildren =
        footerMenu.length > 0 ? menu.items.filter((item) => item["parent-id"] === footerMenu[0].id) : [];
      const footerChildrenObj = { children: footerChildren };
      setAuthMenu(completeUrlSetter(footerChildrenObj, sections));
    });
  };

  const defaultMenuItems = (siteMenuItems) => {
    const menuItems =
      siteMenuItems && siteMenuItems.length ? siteMenuItems.find((item) => item.title === "footer") : null;
    setAuthMenu(menuItems);
  };

  useEffect(() => {
    if (global.location.origin.includes("auth")) {
      if (getCurrentSite(currentPath) === "northamerica" || getCurrentSite(currentPath) === "na") {
        menuSetter();
      } else if (getCurrentSite(currentPath) === "nagorik") {
        menuSetter("nagorik-sangbad");
      } else {
        defaultMenuItems(prothomaloMenuItems);
      }
    } else if (domainSlug === "northamerica" || domainSlug === "nagorik") {
      defaultMenuItems(micrositesMenuItems);
    } else {
      defaultMenuItems(prothomaloMenuItems);
    }
  }, [micrositesMenuItems, currentPath]);

  return (
    <div styleName="footer">
      <div styleName={`row1 ${pageType === "home-page" ? "no-border" : ""}`} className="print-footer-row1">
        <div styleName="logo">{logoRenderer(footerLogo, currentPath)}</div>

        {authMenu && authMenu.children && authMenu.children.length > 0 ? (
          <div styleName="footer-links" className="print-footer-links">
            <FooterMenuGroup links={authMenu.children.slice(0, 7)} language={publisherAttributes.lang} />
          </div>
        ) : null}
      </div>
      <div styleName="row2" className="print-footer-row2">
        <div styleName="social-links">
          {socialShareLinks["facebook-url"] && (
            <Link href={socialShareLinks["facebook-url"]} target="_blank" rel="noopener noreferrer">
              <Facebook color1="#eee" color2="#121212" />
            </Link>
          )}
          {socialShareLinks["twitter-url"] && (
            <Link href={socialShareLinks["twitter-url"]} target="_blank" rel="noopener noreferrer">
              <Twitter color1="#eee" color2="#121212" />
            </Link>
          )}
          {socialShareLinks["instagram-url"] && (
            <Link href={socialShareLinks["instagram-url"]} target="_blank" rel="noopener noreferrer">
              <Instagram color1="#eee" color2="#121212" />
            </Link>
          )}
          {socialShareLinks["youtube-url"] && (
            <Link
              href={socialShareLinks["youtube-url"]}
              className="youtube-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Youtube />
            </Link>
          )}
        </div>
        <div styleName="app">
          <MobilePlayStore />
        </div>
      </div>
      <div styleName={`row3 ${publisherAttributes.lang === "en" ? "eng-row3" : ""}`}>
        <div styleName="copyright">{publisherSettings.copyright || ""}</div>
        <div styleName="static-links" className="print-static-links">
          {initialFooterBottomLinks && initialFooterBottomLinks.length ? (
            <StaticFooterLinks links={initialFooterBottomLinks} />
          ) : null}
        </div>
        {lastFooterBottomLinks && (
          <div styleName="default-editor" className="print-default-editor">
            {lastFooterBottomLinks["item-type"] === "placeholder" ? (
              <span>{lastFooterBottomLinks.title}</span>
            ) : (
              <a href={lastFooterBottomLinks.completeUrl}>{lastFooterBottomLinks.title}</a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  micrositesMenuItems: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  publisherSettings: get(state, ["qt", "config", "publisher-settings"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  prothomaloMenuItems: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
  pageType: get(state, ["qt", "pageType"], ""),
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
});

DefaultFooterBase.propTypes = {
  staticFooterLinks: array,
  publisherSettings: object,
  prothomaloMenuItems: array,
  pageType: string,
  publisherAttributes: object,
  socialLinks: object,
  currentPath: string,
  domainSlug: string,
  micrositesMenuItems: array,
  customSocialLinks: object,
  sections: array,
};

export const DefaultFooter = connect(mapStateToProps)(DefaultFooterBase);
